export default __webpack_public_path__ + "static/air-corporate-logo-723841a6a4272748585d32d5eab9b775.svg";